import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const AddressDisplay = ({ address }) => {
  const { t } = useTranslation(['backoffice']);

  return (
    <Row>
      {address.first_name && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('name')}: {address.first_name}</p>
        </Col>
      )}
      {address.last_name && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('apellido')}: {address.last_name}</p>
        </Col>
      )}
      {address.email && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('correoelectronico')}: {address.email}</p>
        </Col>
      )}
      {(address.phone || address.phone_number) && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('telefono')}: {address.phone || address.phone_number}</p>
        </Col>
      )}
      {address.address && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('direccion')}: {address.address}</p>
        </Col>
      )}
      {address.postal_code && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('postalcode')}: {address.postal_code}</p>
        </Col>
      )}
      {address.locality && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('localidad')}: {address.locality}</p>
        </Col>
      )}
      {address.province && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('province')}: {address.province.label}</p>
        </Col>
      )}
      {address.country && (
        <Col xs={12} md={4}>
          <p className="mt-4">{t('pais')}: {address.country.label}</p>
        </Col>
      )}
    </Row>
  );
};

AddressDisplay.propTypes = {
  address: PropTypes.object,
};

export default AddressDisplay;
